"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePagedResource = void 0;
var tslib_1 = require("tslib");
// (C) 2007-2021 GoodData Corporation
var react_1 = require("react");
var usePromiseCache_1 = require("./usePromiseCache");
/**
 * Hook for getting data from paged resource
 * @public
 */
function usePagedResource(resourceFactory, fetchParams, fetchDeps, resetDeps, getCacheKey, initialState) {
    if (initialState === void 0) { initialState = {
        totalItemsCount: undefined,
        items: [],
    }; }
    var _a = tslib_1.__read(react_1.useState(initialState), 2), state = _a[0], setState = _a[1];
    var reset = function () { return setState(initialState); };
    var mergeResult = function (result) {
        return setState(function (state) {
            var isFirstResult = typeof state.totalItemsCount === "undefined";
            var items = isFirstResult ? new Array(result.totalCount) : tslib_1.__spread(state.items);
            items.splice.apply(items, tslib_1.__spread([result.offset, result.limit], result.items));
            return {
                totalItemsCount: result.totalCount,
                items: items,
            };
        });
    };
    var _b = usePromiseCache_1.usePromiseCache(resourceFactory, fetchParams, fetchDeps, resetDeps, getCacheKey), isLoading = _b.isLoading, results = _b.results;
    react_1.useEffect(function () {
        // We want to reset state only after resetDeps are changed, not on first run
        return function () {
            reset();
        };
    }, resetDeps);
    react_1.useEffect(function () {
        results.forEach(mergeResult);
    }, [results]);
    var items = state.items, totalItemsCount = state.totalItemsCount;
    return {
        isLoading: isLoading,
        items: items,
        totalItemsCount: totalItemsCount,
    };
}
exports.usePagedResource = usePagedResource;
//# sourceMappingURL=usePagedResource.js.map